import { lazy } from 'react';
import { EmergencyMessageProps } from './EmergencyMessage.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() => lazyRetry(() => import(/* webpackChunkName: "emergencyMessage" */ './EmergencyMessage')));

const LazyComponentWithSuspense = withSuspense<EmergencyMessageProps>(LazyComponent, 'EmergencyMessage', '');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponentWithSuspense as EmergencyMessage };
